import React, { useEffect } from 'react'
import { Outlet } from 'react-router-dom';
// import Header from './Header'
import Footer from './Footer'
// import Header from "./Header"
import Navbar from "./Navbar"
import WhatsAppButton from './WhatsAppButton';
const UserLayout = () => {

  return (
    <div>
        {/* <Header/> */}
        <Navbar/>
            <Outlet/>
        <Footer/>
        <WhatsAppButton/>
    </div>
  )
}

export default UserLayout